// extracted by mini-css-extract-plugin
export var filterIncDec = "_9i-0";
export var leftBorder = "_9i-1";
export var rightBorder = "_9i-2";
export var stringInput = "_9i-3";